import { useEffect, useState } from "react";
import {
  getStorage,
  ref,
  getDownloadURL,
  list,
} from "firebase/storage";
import { Gallery, Item } from "react-photoswipe-gallery";
import "./index.scss";
import { useUser } from "../../context/UserContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderSrc from "../../images/logo.png";

const PAGE_SIZE = 20;

function OurProjects() {
  const [images, setImages] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const { translate } = useUser();
  const storage = getStorage();

  const options = {
    wheelToZoom: true,
  };

  const loadImages = async (pageToken = undefined) => {
    if (loading) return;

    setLoading(true);

    try {
      const listRef = ref(storage, "our_projects/");

      const result = await list(listRef, {
        maxResults: PAGE_SIZE,
        pageToken,
      });

      const urls = await Promise.all(
        result.items.map((item) => getDownloadURL(item))
      );

      setImages((prev) => [...prev, ...urls]);

      setNextPageToken(result.nextPageToken || null);
      setHasMore(!!result.nextPageToken);
    } catch (err) {
      console.error(err);
      alert("Error happened, please contact support!");
    }

    setLoading(false);
  };

  useEffect(() => {
    loadImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ourProjectsPage container p-4">
      <h1 className="fw-bold text-center mb-5">
        {translate("park_projects")}
      </h1>

      <Gallery options={options}>
        <div className="d-flex gap-3 gap-md-4 flex-wrap">
          {images.map((img) => (
            <Item
              key={img}
              original={img}
              thumbnail={img}
              width="1024"
              height="768"
            >
              {({ ref, open }) => (
                <div className="img-wrapper">
                  <LazyLoadImage
                    ref={ref}
                    className="img-fluid rounded-4"
                    src={img}
                    onClick={open}
                    placeholderSrc={placeholderSrc}
                    effect="blur"
                    alt="Project"
                  />
                </div>
              )}
            </Item>
          ))}
        </div>
      </Gallery>

      {hasMore && (
        <div className="text-center mt-5">
          <button
            className="btn btn-primary loadMore"
            onClick={() => loadImages(nextPageToken)}
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}
    </div>
  );
}

export default OurProjects;